export const validateAlphabets = (text) => {
    const regex = /^[A-Za-z\s]+$/;
    return regex.test(text);
};

export const validationNumbers = (text) => {
    const regex = /^[0-9]+$/;
    return regex.test(text);
};
